import React, { useState, useRef, useEffect } from "react";
import leftArrowBtsIcon from '../../../../Assets/Icons/left-btn.png'
import Dropdown from "../../../../Components/Dropdown";
import GstServiceController from "../../../Controllers/AdminScreens/Services/GstServiceController";
import LoadingSkeleton from "../../../../Components/LoadingSkeleton";
import Loader from "../../../../Components/Loader";
import { useNavigate } from 'react-router-dom';


const GstServiceScreen = () => {

  const sampleNotifications = [
    { message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit." },
    { message: "Curabitur accumsan turpis pharetra augue tincidunt." },
    { message: "Pellentesque habitant morbi tristique senectus et netus." },
    { message: "Suspendisse potenti. Sed porttitor lectus nibh." }
  ];
  const [currentIndex, setCurrentIndex] = useState(0);

  const {
    userPermissions,
    serviceOptions,
    serviceSubOptions,
    statusOptions,
    taskOverview,
    loading,
    handlePendingTask, handleCheckwise, handleSchedule,
    servicesLoading,
    servicesError,
    serviceName,
    subServiceName,
    subServicesLoading,
    subServicesError,
    handleSubServices,
    handleData,
    overViewLoading,
    overViewReportError,
    taskStatus,
    taskStatusLoading,
    taskStatusError,
    dateStatus,
    dateStatusLoading,
    dateStatusError,
    checkwiseStatus,
    checkwiseStatusLoading,
    checkwiseStatusError,
    scheduleInfoList,
    scheduleLoading,
    scheduleResError, scheduleInfoListLoading, checkwiseStatusList,
    notificationList,
    notificationError,
    notificationLoading,
    handleFinancialYear,
    cards,
    cards1,
    toDoListData,
    handleTaskwise,
    cards2, handleUserWiseReport,
    cards3, taskCheckList, taskCheckLoading, taskCheckError,
    count, countError, countLoading,
    handleOverallReport,
    toDoReportError, toDoLoading,
    handleToDoNavigation
  } = GstServiceController();


  // Function to navigate to the next notification
  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % notificationList?.length);
  };

  // Function to navigate to the previous notification
  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      (prevIndex - 1 + notificationList?.length) % notificationList?.length
    );
  };
  // Function to truncate notification if it exceeds 100 characters
  const getTruncatedNotification = (notification) => {
    return notification?.nb_message.length > 100 ? `${notification?.nb_message.substring(0, 100)}...` : notification?.nb_message;
  };

  const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
  const toggleDropdown = (dropdownName) => {
    setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  const dropdownRefs = useRef({}); // Ref for dropdown

  // Handle clicks outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutside = Object.keys(dropdownRefs.current).every(
        (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
      );
      if (isOutside) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div style={styles.container}>

      <div className="notifications-taskoverview-wrapper" style={{ marginBottom: 50 }}>
        <div className='title-container' style={{ paddingBottom: 10, justifyContent: 'flex-start', gap: '25px' }}>
          <h2 className='title'>Service Dashboard</h2>
          <div>
            <Dropdown
              ref={(el) => (dropdownRefs.current["serviceName"] = el)}
              isOpen={openDropdown === "serviceName"}
              toggleDropdown={() => toggleDropdown("serviceName")}
              options={serviceOptions}
              style={{ backgroundColor: '#fff', borderRadius: '50px', width: '165px' }}
              onChange={(selectedOption) => handleSubServices(selectedOption, '')}
              value={serviceName}
              loading={servicesLoading}
              top='100%'
            />
            {servicesError && !servicesLoading && (
              <p style={{ color: 'red', fontSize: '12px', textAlign: 'center', width: '165px' }}>{servicesError}</p>
            )}
          </div>
          <div>
            <Dropdown
              ref={(el) => (dropdownRefs.current["subServiceName"] = el)}
              isOpen={openDropdown === "subServiceName"}
              toggleDropdown={() => toggleDropdown("subServiceName")}
              options={serviceSubOptions}
              style={{ backgroundColor: '#fff', borderRadius: '50px', width: '165px' }}
              onChange={(selectedOption) => handleData(serviceName, selectedOption)}
              value={subServiceName}
              loading={subServicesLoading}
              top='100%'
            />
            {subServicesError && !subServicesLoading && (
              <p style={{ color: 'red', fontSize: '12px', textAlign: 'center', width: '165px' }}>{subServicesError}</p>
            )}
          </div>
        </div>
        <div className="notifications-section">
          <div className="notifications-header">
            <h3 className='notifications-heading'>Notifications</h3>
            <div className="notification-message">
              {getTruncatedNotification(notificationList[currentIndex])}
              {notificationLoading && <LoadingSkeleton width="540px" height="15px" />}
              {notificationError && <div className="list-error-msg">{notificationError} </div>}
            </div>
            <div className="notification-navigation">
              <button className="nav-button" onClick={handlePrevious} style={{ cursor: currentIndex === 0 ? 'not-allowed' : 'pointer', pointerEvents: currentIndex === 0 ? 'none' : 'auto', background: 'none' }}>
                <img src={leftArrowBtsIcon} alt="Previous" style={{ height: '22px', width: '22px' }} />
              </button>

              <button className="nav-button" onClick={handleNext} style={{ cursor: currentIndex === notificationList.length - 1 ? 'not-allowed' : 'pointer', pointerEvents: currentIndex === notificationList.length - 1 ? 'none' : 'auto', background: 'none' }}>
                <img src={leftArrowBtsIcon} alt="Next" className="rotate-icon" style={{ height: '22px', width: '22px' }} />
              </button>
            </div>
          </div>

        </div>
        <div className="task-overview-section" style={{ marginTop: '-5px' }}>
          <div className="overview-content">
            <h3 className="task-overview-title">Tasks<br />Overview</h3>
            {taskOverview?.length === 0 && !overViewLoading
              ? // Initial state: Display '--'
              [...Array(5)].map((_, index) => (
                <div className="task-overview-item" key={index}>
                  <h4 className="task-count">--</h4>
                  <div className="task-label-container">
                    <p className="task-label">--</p>
                  </div>
                </div>
              ))
              : overViewLoading
                ? // Loading state: Display skeletons
                [...Array(5)].map((_, index) => (
                  <div className="task-overview-item" key={index}>
                    <h4 className="task-count" style={{ paddingBottom: overViewLoading ? 5 : 0 }}>
                      <LoadingSkeleton width="40px" height="10px" />
                    </h4>
                    <div className="task-label-container">
                      <div className="task-label">
                        <LoadingSkeleton width="80px" height="10px" />
                      </div>
                    </div>
                  </div>
                ))
                : // Data state: Display data
                taskOverview?.map((item, index) => (
                  <div className="task-overview-item" style={{ cursor: item?.value !== '--' && item?.value > 0 ? 'pointer' : 'not-allowed' }} key={index} onClick={() => handlePendingTask('overview_report', item)}>
                    <h4 className="task-count">{(typeof item?.value === "number" && !isNaN(item?.value)) ? (item?.value < 10 ? `0${item?.value}` : item?.value) : item?.value}</h4>
                    <div className="task-label-container">
                      <p className="task-label">{item?.label ?? '--'}</p>
                    </div>
                  </div>
                ))}
          </div>
        </div>

      </div>

      {/* Sections */}

      <div style={styles.sections}>
        <div style={styles.sectionCard}>
          <h4 style={styles.sectionTitle}>Task with Status</h4>

          {/* Display placeholders or data */}
          {taskStatus?.length > 0 &&
            taskStatus?.map((task, index) => (
              <div key={index} style={styles.sectionItem} className="nth-child-color">
                <p>{task?.label}</p>
                <span style={{ ...styles.itemValue, textDecoration: task?.value === '--' ? 'none' : 'underline', cursor: task?.value !== '--' && task?.value > 0 ? 'pointer' : 'not-allowed' }}
                  onClick={() => handlePendingTask('task_status', task)}>
                  {taskStatusLoading ? (
                    <LoadingSkeleton width="50px" height="10px" />
                  ) : (
                    (typeof task?.value === "number" && !isNaN(task?.value)) ? (task?.value < 10 ? `0${task?.value}` : task?.value) : task?.value
                  )}
                </span>
              </div>
            ))}

          {/* Display error if there's an error and not loading */}
          {taskStatusError && !taskStatusLoading && (
            <p style={{ color: 'red', fontSize: '12px' }}>{taskStatusError}</p>
          )}
        </div>

        <div style={{...styles.sectionCard,flex: window.innerWidth <= 768 ? '1 1 100%' : '0 1 calc(34% - 20px)',}}>
          <h4 style={styles.sectionTitle}>Task with Due Dates</h4>

          {/* Display placeholders or data */}
          {dateStatus?.length > 0 &&
            dateStatus?.map((task, index) => (
              <div key={index} style={styles.sectionItem} className="nth-child-color">
                <p>{task?.label}</p>
                <span style={{ ...styles.itemValue, textDecoration: task?.value === '--' ? 'none' : 'underline', cursor: task?.value !== '--' && task?.value > 0 ? 'pointer' : 'not-allowed' }}
                  onClick={() => handlePendingTask('dates_report', task)}>
                  {dateStatusLoading ? (
                    <LoadingSkeleton width="50px" height="10px" />
                  ) : (
                    (typeof task?.value === "number" && !isNaN(task?.value)) ? (task?.value < 10 ? `0${task?.value}` : task?.value) : task?.value
                  )}
                </span>
              </div>
            ))}

          {/* Display error if there's an error and not loading */}
          {dateStatusError && !dateStatusLoading && (
            <p style={{ color: 'red', fontSize: '12px' }}>{dateStatusError}</p>
          )}
        </div>

        <div style={styles.sectionCard}>
          <h4 style={styles.sectionTitle}>Schedule</h4>
          <div className="scrollableContainer"
            style={{
              height: '190px',
              overflowY: 'auto',
              paddingRight: '10px',
              marginRight: '-15px',
            }}>
            {/* Display placeholders or data */}
            {scheduleInfoList?.length > 0 ?
              scheduleInfoList?.map((task, index) => (
                <div key={index} style={styles.sectionItem} className="nth-child-color">
                  <p>{task?.sc_type_name}</p>
                  <span style={{ ...styles.itemValue, textDecoration: task?.sc_count === '--' ? 'none' : 'underline', cursor: task?.sc_count !== '--' && task?.sc_count > 0 ? 'pointer' : 'not-allowed' }} onClick={() => handleSchedule('schedule_report', task)}>
                    {scheduleLoading ? (
                      <LoadingSkeleton width="50px" height="10px" />
                    ) : (
                      (typeof task?.sc_count === "number" && !isNaN(task?.sc_count)) ? (task?.sc_count < 10 ? `0${task?.sc_count}` : task?.sc_count) : task?.sc_count
                    )}
                  </span>
                </div>
              )) : scheduleLoading ? (
                [...Array(3)].map((_, index) => (
                  <div key={index} style={styles.sectionItem} className="nth-child-color">
                    <LoadingSkeleton width="100px" height="10px" />
                    <LoadingSkeleton width="50px" height="10px" />
                  </div>
                ))
              ) : null
            }
            {/* Display error if there's an error and not loading */}
            {scheduleResError && !scheduleLoading && (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'inherit' }}>
                <p style={{ color: 'red', fontSize: '12px', textAlign: 'center' }}>{scheduleResError}</p>
              </div>
            )}
          </div>




        </div>
        <div style={{ flex: window.innerWidth <= 768 ? '1 1 100%' : '0 1 calc(34% - 20px)', }}>
          <div style={{ ...styles.sectionCard, height: '220px' }}>
            <h4 style={styles.sectionTitle}>Checkwise pending Tasks</h4>
            <div
              className="scrollableContainer"
              style={{
                height: '190px',
                overflowY: 'auto',
                paddingRight: '10px',
                marginRight: '-15px',
              }}
            >
              {/* Display placeholders or data */}
              {checkwiseStatusList?.length > 0 ?
                checkwiseStatusList?.map((task, index) => (
                  <div key={index} style={styles.sectionItem} className="nth-child-color">
                    <p>{task?.service_check_name}</p>
                    <span style={{ ...styles.itemValue, textDecoration: task?.task_check_count === '--' ? 'none' : 'underline', cursor: task?.task_check_count !== '--' && task?.task_check_count > 0 ? 'pointer' : 'not-allowed' }}
                      onClick={() => handleCheckwise('checkwise_report', task)}>
                      {checkwiseStatusLoading ? (
                        <LoadingSkeleton width="50px" height="10px" />
                      ) : (
                        (typeof task?.task_check_count === "number" && !isNaN(task?.task_check_count)) ? (task?.task_check_count < 10 ? `0${task?.task_check_count}` : task?.task_check_count) : task?.task_check_count
                      )}
                    </span>
                  </div>
                )) : checkwiseStatus?.map((task, index) => (
                  <div key={index} style={styles.sectionItem} className="nth-child-color">
                    <p>{task?.label}</p>
                    <span style={{ ...styles.itemValue, cursor: task?.value !== '--' && task?.value > 0 ? 'pointer' : 'not-allowed' }}>
                      {checkwiseStatusLoading ? (
                        <LoadingSkeleton width="50px" height="10px" />
                      ) : (
                        task?.value
                      )}
                    </span>
                  </div>
                ))}
            </div>

            {/* Display error if there's an error and not loading */}
            {checkwiseStatusError && !checkwiseStatusLoading && (
              <p style={{ color: 'red', fontSize: '12px' }}>{checkwiseStatusError}</p>
            )}

          </div>
          {/* <div style={{ ...styles.sectionCard, marginTop: '10px', padding: '15px' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={styles.sectionTitle1}>View All Tasks</div>
            </div>
          </div> */}
        </div>




        {/* <div style={{ display: 'flex', flexDirection: 'row' }}> */}
        <div style={styles.container1}>
          <div style={styles.container1}>
            {cards.map((card, index) => (
              <div key={index} style={styles.card}>
                <div style={styles.cardTitle}>{card.title}</div>
                <div style={{ ...styles.dropdownContainer, padding: '0px', gap: '0px' }}>
                  <div style={{ ...styles.dropdownContainer, flex: 'auto' }}>
                    {card.dropdowns.map((dropdown, idx) => (
                      <Dropdown
                        ref={(el) => (dropdownRefs.current[dropdown?.label] = el)}
                        isOpen={openDropdown === dropdown?.label}
                        toggleDropdown={() => toggleDropdown(dropdown?.label)}
                        key={idx}
                        options={dropdown.options}
                        value={dropdown.value}
                        onChange={dropdown.setValue}
                        style={{ backgroundColor: '#fff', borderRadius: '50px', width: dropdown?.dropdownWidth, height: '11px', fontSize: 12 }}
                        loading={dropdown?.loading}
                        errorMessage={dropdown?.error}
                        top='100%'
                      />
                    ))}
                  </div>
                  <div style={{ flex: 'auto', marginTop: 13 }}>
                    <img src={require("../../../../Assets/Icons/right_arrow_button.png")} alt="Go" style={{ height: '32px', width: '32px', cursor: serviceName && subServiceName && card.dropdowns.every((d) => d.value) ? 'pointer' : 'not-allowed' }}
                      onClick={serviceName && subServiceName && card.dropdowns.every((d) => d.value) ? () => handleFinancialYear('financial_year_report') : null} />
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div style={styles.container1}>
            {cards2.map((card, index) => (
              <div key={index} style={styles.card}>
                <div style={styles.cardTitle}>{card.title}</div>
                <div style={{ ...styles.dropdownContainer, padding: '0px', gap: '0px' }}>
                  <div style={{ ...styles.dropdownContainer, gap: '8px', flexDirection: 'column', flex: 'auto' }}>
                    {card.dropdowns.map((dropdown, idx) => (
                      <Dropdown
                        ref={(el) => (dropdownRefs.current[dropdown?.label] = el)}
                        isOpen={openDropdown === dropdown?.label}
                        toggleDropdown={() => toggleDropdown(dropdown?.label)}
                        key={idx}
                        options={dropdown?.options}
                        value={dropdown?.value}
                        onChange={(value) => dropdown?.function(value)}
                        style={{ backgroundColor: '#fff', borderRadius: '50px', width: dropdown?.dropdownWidth, height: '11px', fontSize: 12 }}
                        loading={dropdown?.loading}
                        errorMessage={dropdown?.error}
                        defaultPlaceholder={dropdown?.placeholder || "Select"}
                        top='100%'
                      />
                    ))}

                    {countError && !countLoading && (
                      <p style={{ color: 'red', fontSize: '12px' }}>{countError}</p>
                    )}

                  </div>
                  <div style={{ flex: 'auto', marginBottom: 20, display: 'flex', alignItems: 'end' }}>
                    <span style={{ ...styles.itemValue, marginTop: '15px', textDecoration: count === '--' ? 'none' : 'underline', cursor: count !== '--' && count > 0 ? 'pointer' : 'not-allowed' }}>
                      {countLoading ? (
                        <LoadingSkeleton width="20px" height="10px" />
                      ) : (
                        (typeof count === "number" && !isNaN(count)) ? (count < 10 ? `0${count}` : count) : count
                      )}
                    </span>
                  </div>

                  {/* <button style={{ ...styles.iconButton, cursor: serviceName && subServiceName && card.dropdowns.every((d) => d.value) ? 'pointer' : 'not-allowed' }} onClick={serviceName && subServiceName && card.dropdowns.every((d) => d.value) ? () => handleUserWiseReport('userwise_report') : null}> */}
                  <div style={{ flex: 'auto', marginBottom: 13, display: 'flex', alignItems: 'end' }} >
                    <img src={require("../../../../Assets/Icons/right_arrow_button.png")} alt="Go" style={{ height: '32px', width: '32px', cursor: serviceName && subServiceName && card.dropdowns.every((d) => d.value) && count > 0 ? 'pointer' : 'not-allowed' }}
                      onClick={serviceName && subServiceName && card.dropdowns.every((d) => d.value) && count > 0 ? () => handleUserWiseReport('userwise_report') : null} />
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div style={styles.container1}>
            {cards3.map((card, index) => (
              <div key={index} style={styles.card}>
                <div style={styles.cardTitle}>{card.title}</div>
                <div style={{ ...styles.dropdownContainer, padding: '0px', gap: '0px' }}>
                  <div style={{ ...styles.dropdownContainer, flex: 'auto' }}>
                    {card.dropdowns.map((dropdown, idx) => (
                      <Dropdown
                        ref={(el) => (dropdownRefs.current[dropdown?.label] = el)}
                        isOpen={openDropdown === dropdown?.label}
                        toggleDropdown={() => toggleDropdown(dropdown?.label)}
                        key={idx}
                        options={dropdown.options}
                        value={dropdown.value}
                        onChange={dropdown.setValue}
                        style={{ backgroundColor: '#fff', borderRadius: '50px', width: dropdown?.dropdownWidth, height: '11px', fontSize: 12 }}
                        loading={dropdown?.loading}
                        errorMessage={dropdown?.error}
                        defaultPlaceholder={dropdown?.placeholder || "Select"}
                        top='100%'
                      />
                    ))}
                    <div style={{ flex: 'auto', marginTop: 4, display: 'flex', justifyContent: window.innerWidth <= 768 ? undefined : 'center', paddingLeft: window.innerWidth <= 768 ? 0 : 12, }}>
                      <img src={require("../../../../Assets/Icons/right_arrow_button.png")} alt="Go" style={{ height: '32px', width: '32px', cursor: serviceName && subServiceName && card.dropdowns.every((d) => d.value) ? 'pointer' : 'not-allowed' }}
                        onClick={serviceName && subServiceName && card.dropdowns.every((d) => d.value) ? () => handleOverallReport('overall_report') : null} />
                    </div>
                  </div>
                  {/* <div style={{flex: 'auto', marginTop: 14}}>
                    <img src={require("../../../../Assets/Icons/right_arrow_button.png")} alt="Go" style={{height:'32px',width:'32px',cursor: serviceName && subServiceName && card.dropdowns.every((d) => d.value) ? 'pointer' : 'not-allowed'}}
                      onClick={serviceName && subServiceName && card.dropdowns.every((d) => d.value) ? () => handleOverallReport('overall_report') : null} />
                  </div> */}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div style={styles.container1}>
          {cards1.map((card, index) => (
            <div key={index} style={styles.card}>
              <div style={styles.cardTitle}>{card.title}</div>
              <div style={{ ...styles.dropdownContainer, padding: '0px', gap: '0px' }}>
                <div style={{ ...styles.dropdownContainer, flex: 'auto' }}>
                  {card.dropdowns.map((dropdown, idx) => (
                    <Dropdown
                      ref={(el) => (dropdownRefs.current[dropdown?.label] = el)}
                      isOpen={openDropdown === dropdown?.label}
                      toggleDropdown={() => toggleDropdown(dropdown?.label)}
                      key={idx}
                      options={dropdown.options}
                      value={dropdown.value}
                      onChange={dropdown.setValue}
                      style={{ backgroundColor: '#fff', borderRadius: '50px', width: dropdown?.dropdownWidth, height: '11px', fontSize: 12 }}
                      loading={dropdown?.loading}
                      errorMessage={dropdown?.error}
                      defaultPlaceholder={dropdown?.placeholder || "Select"}
                      top='100%'
                    />
                  ))}
                </div>
                <div style={{ flex: 'auto', marginTop: 14 }}>
                  <img src={require("../../../../Assets/Icons/right_arrow_button.png")} alt="Go" style={{ height: '32px', width: '32px', cursor: serviceName && subServiceName && card.dropdowns.every((d) => d.value) ? 'pointer' : 'not-allowed' }}
                    onClick={serviceName && subServiceName && card.dropdowns.every((d) => d.value) ? () => handleTaskwise('taskwise_group_report') : null} />
                </div>
              </div>
            </div>
          ))}
          <div style={styles.card}>
            <div style={styles.cardTitle}>To Do List Report</div>
            <div style={styles.dropdownContainer}>
              <div style={styles.tableContainer}>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.tableHeader}>Task Status</th>
                      <th style={styles.tableHeader}>Taskwise</th>
                      <th style={styles.tableHeader}>File No.</th>
                      <th style={{ ...styles.tableHeader, ...styles.lastColumnCell }}>Without</th>
                    </tr>
                  </thead>
                  <tbody>
                    {toDoListData.map((row, index) => (
                      <tr
                        key={index}
                        style={styles.tableRowEven}
                      >
                        <td style={{ ...styles.tableTextCell, color: '#40513B', fontSize: '10px', fontWeight: '400', backgroundColor: '#fff' }} >{row.taskStatus}</td>
                        <td style={{ ...styles.tableCell, textDecoration: row.taskwise === '--' ? '' : 'underline' }} onClick={() => {
                          if (row.taskwise !== 0) {
                            handleToDoNavigation('taskwise', row.taskStatus);
                          }
                        }}>{toDoLoading ? <LoadingSkeleton width="30px" height="10px" /> : (typeof row?.taskwise === "number" && !isNaN(row?.taskwise)) ? (row?.taskwise < 10 ? `0${row?.taskwise}` : row?.taskwise) : row?.taskwise}</td>
                        <td style={{ ...styles.tableCell, textDecoration: row.fileNo === '--' ? '' : 'underline' }} onClick={() => {
                          if (row.fileNo !== 0) {
                            handleToDoNavigation('filewise', row.taskStatus);
                          }
                        }}>{toDoLoading ? <LoadingSkeleton width="30px" height="10px" /> : (typeof row?.fileNo === "number" && !isNaN(row?.fileNo)) ? (row?.fileNo < 10 ? `0${row?.fileNo}` : row?.fileNo) : row?.fileNo}</td>
                        <td style={{ ...styles.tableCell, ...styles.lastColumnCell, textDecoration: row.without === '--' ? '' : 'underline' }}>{toDoLoading ? <LoadingSkeleton width="30px" height="10px" /> : (typeof row?.without === "number" && !isNaN(row?.without)) ? (row?.without < 10 ? `0${row?.without}` : row?.without) : row?.without}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {toDoReportError && <div className="list-error-msg">{toDoReportError} </div>}
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
      </div>


      {/* Financial Year Report */}
      {/* <div style={{ padding: '0px 20px' }}>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={styles.container1}>
          {cards.map((card, index) => (
            <div key={index} style={styles.card}>
              <div style={styles.cardTitle}>{card.title}</div>
              <div style={styles.dropdownContainer}>
                <div style={styles.dropdownContainer}>
                  {card.dropdowns.map((dropdown, idx) => (
                    <Dropdown
            ref={(el) => (dropdownRefs.current[""] = el)}
isOpen={openDropdown === " "}
toggleDropdown={() => toggleDropdown(" ")}
                      key={idx}
                      options={dropdown.options}
                      value={dropdown.value}
                      onChange={dropdown.setValue}
                      style={{ backgroundColor: '#fff', borderRadius: '50px', width: '80px' }}
                    />
                  ))}
                </div>
                <div>
                  <button style={styles.iconButton}>
                    <img src={require("../../../../Assets/Icons/right_arrow_button.png")} alt="Go" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div style={styles.container1}>
          {cards1.map((card, index) => (
            <div key={index} style={styles.card}>
              <div style={styles.cardTitle}>{card.title}</div>
              <div style={styles.dropdownContainer}>
                <div style={styles.dropdownContainer}>
                  {card.dropdowns.map((dropdown, idx) => (
                    <Dropdown
            ref={(el) => (dropdownRefs.current[""] = el)}
isOpen={openDropdown === " "}
toggleDropdown={() => toggleDropdown(" ")}
                      key={idx}
                      options={dropdown.options}
                      value={dropdown.value}
                      onChange={dropdown.setValue}
                      style={{ backgroundColor: '#fff', borderRadius: '50px', width: '80px' }}
                    />
                  ))}
                </div>
                <div>
                  <button style={styles.iconButton}>
                    <img src={require("../../../../Assets/Icons/right_arrow_button.png")} alt="Go" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div> */}
    </div>
  );
};

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    padding: "20px",
    display: 'grid',
  },
  notifications: {
    backgroundColor: "#f9f9f9",
    padding: "10px",
    borderRadius: "5px",
    marginBottom: "20px",
  },
  taskOverview: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  taskOverviewCard: {
    flex: 1,
    textAlign: "center",
    margin: "5px",
    backgroundColor: "#fff",
    padding: "15px",
    borderRadius: "5px",
    boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
  },
  taskLabel: {
    fontSize: "14px",
    color: "#888",
  },
  taskValue: {
    fontSize: "24px",
    fontWeight: "bold",
    margin: "5px 0",
  },
  sections: {
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
    padding: '0px 20px'
  },
  sectionCard: {
    flex: "1 1 calc(25% - 20px)",
    backgroundColor: "#fff",
    borderRadius: "5px",
    padding: "15px",
    boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: "400",
    marginBottom: "10px",
    color: '#060606',
    marginTop: '0px',
    fontFamily: 'Roboto Slab',

  },
  sectionItem: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "5px",
    padding: '20px 10px',
    fontSize: '14px',
    color: '#505470',
    fontWeight: '400',
  },
  itemValue: {
    fontWeight: "700",
    color: "#5A55D2",
    fontSize: '16px',
  },
  reportSection: {
    marginTop: "20px",
    padding: "15px",
    backgroundColor: "#fff",
    borderRadius: "5px",
    boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
  },
  dropdown: {
    margin: "10px 0",
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid #ddd",
    width: "100%",
  },
  container1: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    // padding: "20px",
    flex: "1 1 calc(25% - 20px)",
  },
  card: {
    // width: "300px",
    // minHeight: "160px",
    padding: "20px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    display: "flex",
    flexDirection: "column",
  },
  cardTitle: {
    fontSize: "18px",
    fontWeight: "400",
    marginBottom: "15px",
    textAlign: "left",
    color: '#060606',
    fontFamily: 'Roboto Slab',
  },
  dropdownContainer: {
    backgroundColor: '#F7F8FA',
    display: "flex",
    flexDirection: "row",
    gap: "10px",
    padding: '10px',
    borderRadius: '10px',
    flexWrap: 'wrap',
  },
  iconButton: {
    border: "none",
    borderRadius: "50%",
    height: '10px',
    width: '10px',
    cursor: "pointer",
    marginTop: '15px',
    background: 'none',
  },
  scrollableContainer: {
    height: "200px", // Set fixed height
    overflowY: "auto", // Enable vertical scrolling
    paddingRight: "10px", // Add padding for scrollbar spacing
  },
  sectionTitle1: {
    textDecoration: 'underline',
    color: '#5A55D2',
    fontFamily: 'Roboto',
    fontWeight: '590',
    fontSize: '16px',
    cursor: 'pointer',
  },
  tableContainer: {
    width: "100%",
    overflowX: "auto",
    backgroundColor: "#fff",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    textAlign: "center",
    fontFamily: "Roboto, Arial, sans-serif",
    fontSize: "14px",
    border: "1px solid #ddd",
  },
  tableHeader: {
    color: "#40513B",
    padding: "8px",
    borderBottom: "1px solid #ddd",
    borderRight: "1px solid #ddd",
    fontSize: '10px',
    fontWeight: '600',
  },
  tableRowEven: {
    backgroundColor: "#FAFAFA",
  },
  tableCell: {
    borderBottom: "1px solid #ddd",
    borderRight: "1px solid #ddd",
    color: "#5A55D2",
    fontWeight: "700",
    cursor: "pointer",
    textDecoration: 'underline',
    fontSize: '16px',
  },
  tableTextCell: {
    padding: "8px",
    borderBottom: "1px solid #ddd",
    borderRight: "1px solid #ddd",
    color: "#505470",
    fontWeight: "normal",
  },
  lastColumnCell: {
    borderRight: "none",
  },
};

export default GstServiceScreen;
